import './index.sass'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'

const CampaignTheme3 = {
    dark: false,
    colors: {
        background: '#fff',
        surface: '#F7F8FB',
        primary: '#334AC6',
        'primary-darken-1': '#334AC6',
        secondary: '#A0A9C2',
        'secondary-darken-1': '#A0A9C2',
        error: '#B00020',
        info: '#0676C2',
        success: '#1EB26D',
        warning: '#F6C407',
        black: '#171F46',
    },
}

const referralTheme = {
    dark: false,
    colors: {
        background: '#fff',
        surface: '#F7F8FB',
        primary: '#051337',
        'primary-darken-1': '#051337',
        secondary: '#108FE5',
        'secondary-darken-1': '#108FE5',
        error: '#B00020',
        info: '#0676C2',
        success: '#1EB26D',
        warning: '#F6C407',
    },
}

const vuetify = createVuetify({
    theme:{
        defaultTheme:'light',
        themes: {
            CampaignTheme3,
            referralTheme,
        },
    },
    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: {
            mdi,
        }
    },
    components,
    directives,
})

export default vuetify;
